export const currentYear = new Date().getFullYear()
export const selectEmtpy = { id: 0, description: '' };
export const selectSearcherEmtpy = { id: 0, description: '', percentage: 0, categoryId: 0 };

export const personalInfoFields = {
	firstName: 'firstName',
	lastName: 'lastName',
	nss: 'nss',
	email: 'email',
	phone: 'phone',
	position: 'position',
	jobSeniorityId: 'jobSeniorityId',
	description: 'description',
	country: 'country',
	state: 'state',
	currentSalary: 'currentSalary',
	currentCurrency: 'currentCurrency',
	salaryMin: 'salaryMin',
	salaryMax: 'salaryMax',
	currency: 'currency',
	image: 'imgProfile'
};

export const MONTHS = [
	{ id: 1, optionName: "Enero"},
	{ id: 2, optionName: "Febrero"},
	{ id: 3, optionName: "Marzo"},
	{ id: 4, optionName: "Abril"},
	{ id: 5, optionName: "Mayo"},
	{ id: 6, optionName: "Junio"},
	{ id: 7, optionName: "Julio"},
	{ id: 8, optionName: "Agosto"},
	{ id: 9, optionName: "Septiembre"},
	{ id: 10, optionName: "Octubre"},
	{ id: 11, optionName: "Noviembre"},
	{ id: 12, optionName: "Diciembre"},
];

const minYear = 1940;
const maxYear = 2050;

export const yearsOrderAsc = 'asc';
export const yearsOrderDesc = 'desc';

export const yearsHardCode = order => {
	const years = [];
	let id = 1;

	if ( order ) {
		const isOrderDesc = order === yearsOrderDesc;
		const yearTo = isOrderDesc ? minYear : maxYear;

		if( isOrderDesc ) {
			for (let index = currentYear; index >= yearTo; index--) {
				const element = {
					id: id++,
					optionName: `${index}`
				}
				years.push(element);
			}
		} else {
			for (let index = currentYear; index <= yearTo; index++) {
				const element = {
					id: id++,
					optionName: `${index}`
				}
				years.push(element);
			}
		}
	} else {
		for (let index = minYear; index <= maxYear; index++) {
			const element = {
				id: id++,
				optionName: `${index}`
			}
			years.push(element);
		}
	}

	return years;
}